import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { PapiUser } from '@wix/da-papi-types';

export const reactToMessage = createAction(
  `${reduxKey}.REACT_TO_MESSAGE`,
  (messageId: string, emoji_id: number, sectionname: string) => ({
    messageId,
    emoji_id,
    sectionname,
  })
);

export const reactToMessageSuccess = createAction(
  `${reduxKey}.REACT_TO_MESSAGE_SUCCESS`,
  (messageId: string, emoji_id: number) => ({
    messageId,
    emoji_id,
  })
);

export const fetchReactionUsers = createAction(
  `${reduxKey}.FETCH_REACTION_USERS`,
  (messageId: string, emoji_id: number) => ({
    messageId,
    emoji_id,
  })
);

export const fetchReactionUsersSuccess = createAction(
  `${reduxKey}.FETCH_REACTION_USERS_SUCCESS`,
  (messageId: string, emoji_id: number, users: PapiUser[]) => ({
    messageId,
    emoji_id,
    users,
  })
);

export const fetchReactionUsersFailure = createAction(
  `${reduxKey}.FETCH_REACTION_USERS_FAILURE`,
  (messageId: string, emoji_id: number, error: string) => ({
    messageId,
    emoji_id,
    error,
  })
);

export const addCurrentUserToReaction = createAction(
  `${reduxKey}.ADD_CURRENT_USER_TO_REACTION`,
  (messageId: string, emoji_id: number, currentUser: PapiUser) => ({
    messageId,
    emoji_id,
    currentUser,
  })
);

export const removeCurrentUserFromReaction = createAction(
  `${reduxKey}.REMOVE_CURRENT_USER_FROM_REACTION`,
  (messageId: string, emoji_id: number, currentUser: PapiUser) => ({
    messageId,
    emoji_id,
    currentUser,
  })
);

/**
 * When receiving realtime data, the reaction user list for a specific message can become stale. So we need to invalidate it occasionally.
 */
export const invalidateReactionUsersList = createAction(
  `${reduxKey}.INVALIDATE_REACTION_USERS_LIST`,
  (messageId: string) => ({
    messageId,
  })
);

export const maybeEditLastMessage = createAction(
  `${reduxKey}.MAYBE_EDIT_LAST_MESSAGE`,
  () => ({})
);
